import { render, staticRenderFns } from "./question-judge.vue?vue&type=template&id=65fbcfff&scoped=true&"
import script from "./question-judge.vue?vue&type=script&lang=js&"
export * from "./question-judge.vue?vue&type=script&lang=js&"
import style0 from "./question-judge.vue?vue&type=style&index=0&id=65fbcfff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbcfff",
  null
  
)

export default component.exports